import React from 'react'

const Info = () => {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line
        x1='1.41421'
        y1='1'
        x2='24'
        y2='23.5858'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M11.5318 1H12.8276V24.9999H11.5318V21.8762L9.64848 22.899L8.50869 20.7348L11.5318 19.1652V16.4725L7.05017 18.3488L6.80811 21.8316L4.46798 21.6293L4.67063 19.3595L1.88758 20.5006L1.00467 18.2537L3.79893 17.1122L2.12351 15.6051L3.70369 13.789L6.16261 16.1015L11.5319 13.8624V12.9457L6.16261 10.7068L3.6321 13.0189L2.08935 11.2026L3.78306 9.69616L1 8.55484L1.89123 6.30749L4.68604 7.44861L4.50147 5.17884L6.87848 4.97611L7.04949 8.45935L11.5317 10.3356V6.77328L8.57923 5.20405L9.57695 3.03949L11.5317 4.06255L11.5318 1ZM13.8641 3.67286V4.22807C18.529 4.22807 22.4544 8.14934 22.4544 12.9695C22.4544 17.7897 18.5292 21.7114 13.8641 21.7114V22.2662C18.529 22.2662 23 18.0956 23 12.9695C23 7.84341 18.5293 3.67333 13.8641 3.67333V3.67286ZM14.9007 7.32974V14.1869H14.96L14.9574 14.1291L18.5323 16.7583L18.8125 16.2949L15.4192 13.7858V7.32949L14.9007 7.32974ZM13.0866 25H13.3458V1.00009H13.0866V25Z'
        fill='black'
      />
    </svg>
  )
}

export default Info
